import { Storage } from "@/services/Storage";
import { Configuration } from "@/services/Configuration";
import {debugLog, get} from "@/helpers";
import {Pixel} from "@/services/Pixel";
import {Observer} from "@/services/Observer";
import {AbstractShopifyEvent} from "@/services/pixel/events/shopify/AbstractShopifyEvent";

// TODO:
//  - implement window.history.pushState watcher, see watchStates in obot pixelator
export class App {
  isInitialized = false;

  configuration = new Configuration();
  storage = new Storage();
  pixel = new Pixel();
  observer = new Observer();

  services = ['configuration', 'storage', 'pixel', 'observer'];

  async init() {
    if(this.isInitialized) return;

    // this.initBugsnag(); // disabled
    // this.initRejectionHandler();

    await this.initServices();
    this.isInitialized = true
  }

  // initBugsnag() {
  //   const bugsnag = require('@bugsnag/js');
  //   bugsnag.start({
  //     apiKey: '14d3f866a9f2840f5d4fbe78d6ec79d3',
  //     onError: function (event) {
  //       return !app.isInitialized;
  //     }
  //   });
  // }

  initRejectionHandler() {
    // TODO: implement
    const rejectionHandler = (event: PromiseRejectionEvent) => {
      if(app.isInitialized) return;


      const error: Error = event.reason;

console.log('initRejectionHandler: promise', event.promise);
console.log('initRejectionHandler: reason', error.toString());


      // this.pixel.events.debug.error.handle(error);
    }
    window.addEventListener('unhandledrejection', rejectionHandler);
  }

  async initServices() {
    for (const serviceKey of this.services) {
      await this[serviceKey].init();
    }
  }


  configOption(path: string, defaultValue: any = null) {
    return this.configuration.option(path, defaultValue);
  }

  get isSandboxed(): boolean {
    return this.configuration.sandboxed ?? false;
  }

  debug(message:string, data: any = null, level: string = 'debug', persist: boolean = true)
  {
    if(persist) {
      const time = (new Date()).toISOString();
      this.storage.debug.payload.push({time, message, data, level});
    }

    if(this.isSandboxed || !this.configOption('debug.enabled')) return;

    const messagePrefix = this.configOption('debug.messagePrefix');
    if(messagePrefix) message = messagePrefix+' '+message;
    debugLog(message, data, level);
  }

  async pixelEvent(eventName: string, eventPayload: null|Record<any, any> = null, eventContext: null|Record<any, any> = null) {

    const event: null|AbstractShopifyEvent = get(this.pixel.events, eventName);
    if(!event) {
      app.debug(`PixelEvent: "${eventName}" does not exist`, {eventName, eventPayload}, 'error');
      return;
    }

    await event.handle(eventPayload, eventContext);
  }

}

export const app = new App;
